var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1192 16.0596C32.1192 7.18918 24.93 0 16.0596 0C7.18918 0 0 7.18918 0 16.0596C0 23.5875 5.188 29.911 12.1827 31.6487V20.9653H8.87042V16.0596H12.1827V13.9455C12.1827 8.48147 14.6544 5.94707 20.0243 5.94707C21.0406 5.94707 22.7971 6.14781 23.5185 6.34856V10.79C23.1421 10.7524 22.4834 10.7273 21.6616 10.7273C19.0269 10.7273 18.0106 11.7248 18.0106 14.3156V16.0596H23.255L22.3517 20.9653H18.0043V32C25.9588 31.0402 32.1192 24.2713 32.1192 16.0596Z",
    fill: "#7C6CC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/FacebookIcon.8ecb801ea9f3e8426e35238b173ed718.svg";
export { ForwardRef as ReactComponent };